
export const calculateSavingsQuery = `
  query CalculateSavings($input: CalculationRequestInput!) {
    calculateSavings(request: $input) {
      commonTechnical {
        senderId
        sessionId
        transactionReference
        googleAnalyticsId
        googleAnalyticsSessionId
        accessCode
      }
      policyDetails {
        affiliateUrl
        collectivityDescription
        customProperties {
          supplierKrn
        }
        productCode
        productDescription
        refKey
        moneyViewSavings {
          type
          moneyViewBanks {
            ansId
            name
          }
          moneyViewInterestCollections {
            moneyViewAppliedAdditionalInterests {
              code
              condition
              value
            }
            moneyViewInterests {
              appliedAdditionalInterest
              balanceHigh
              balanceLimitOption
              balanceLow
              duration
              effectiveDate
              terminationDate
              value
            }
          }
        }
      }
    }
  }
`;
